import { Link } from './link.model';

export class Folder {
  id: string;
  parentId: string;
  folderName: string;
  version: number;
  _links: { [id: string]: Link };

  constructor(current?: any) {
    if (current) {
      Object.assign(this, current);
    } else {
    }
  }

}
